<div>Lägg till uppdrag/ämbete</div>
<br>
<div class="col-md-11">
  <form [formGroup]="form">
    <div class="row">
      <div style="width:45%;">
        <div *ngIf="!isClerk && !isSysAdmin">
          <label>Institution</label>
          <select class="form-control form-control-sm" #institutionId formControlName="institutionId"
            (change)="getPossibleOfficesEvent($event)" required>
            <option></option>
            <option *ngFor="let i of institutionlist" [value]="i.id">{{i.shortName}} {{i.name}}</option>
          </select>
        </div>
        <!-- Kanslist eller sysadmin -->
        <div *ngIf="isClerk || isSysAdmin" class="form-group">
          <label for="institutionId">Institution</label>
          <div *ngIf="!selectedinstitution">
            <input type="text" class="form-control form-control-sm" aria-label="Assignee" matInput
              [formControl]="myControl" placeholder="Skriv för att söka institution" [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
              (optionSelected)="onSelectionChanged($event)">
              <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                {{option.name}}
                <b>[{{option.shortName}}]</b>
              </mat-option>
            </mat-autocomplete>
          </div>
          <div *ngIf="selectedinstitution">
            <b style="font-size:14px;">{{selectedinstitutionname}}</b>
            <button class="btn border" style="margin-left:20px;" title="Byt institution"
              (click)="selectedinstitution=null;clear();">Byt institution</button>
          </div>
        </div>
      </div>
      <div style="width:45%;margin-left:20px;">
        <div *ngIf="form.get('institutionId').value">
          <label>
            Uppdrag/ämbete
          </label>
          <select class="form-control form-control-sm" id="id" formControlName="officeCommitteeId" required>
            <option></option>
            <option *ngFor="let o of offices" [value]="o.id">{{o.committeeName}}: {{o.officeName}}</option>
          </select>
        </div>
      </div>
    </div>
    <br>
    <div class="row" *ngIf="form.get('institutionId').value">
      <div>
        <label>
          Från datum
        </label>
        <input id="fromDate" type="text" class="form-control form-control-sm" formControlName="fromDate"
          style="width:100px;" mask="0000-00-00" required>
      </div>
      <div style="margin-left:20px;">
        <label>
          Till datum
        </label>
        <input id="toDate" type="text" class="form-control form-control-sm" formControlName="toDate"
          style="width:100px;" mask="0000-00-00" required>
      </div>
    </div>
    <br>
    <div class="row">
      <button class="btn border" (click)="saveOffice()" [disabled]="!form.valid">Spara</button>
      <button class="btn border" (click)="cancel()" style="margin-left:10px;">Avbryt</button>
    </div>
  </form>
</div>
